<template>
	<main id="paxExpress" class="pax_global">
		<HeaderTab :title="$t('pax.suggestions_pax')" :icon="['fal', 'horse']" />
		<div id="paxReverse" class="container-fluid">
			<div class="row justify-content-center">
				<ChoixLangue v-show="step === 1" @langue_choosed="goToCountry"/>
				<ChoixCountry v-show="step === 2" @country_choosed="goToPax"/>
				<template v-if="step > 2">
					<div class="col bstallion">
						<MaresSuggestion :mares_selected.sync="mares_selected" :pax_suggestion="true"></MaresSuggestion>
					</div>
				</template>
			</div>
		</div>
	</main>
</template>


<script type="text/javascript">
	import UserMixin from '@/mixins/User.js'
	import Navigation from '@/mixins/Navigation.js'
	import PaxMixin from '@/mixins/Pax.js'
	import Config from '@/mixins/Config.js'
	import Window from '@/mixins/Window.js'

	export default {
		name: "PaxSuggestion",
		mixins: [UserMixin, Navigation, PaxMixin, Config, Window],
		data () {
			return {
				mares_selected: [],
				step: 1,
			}
		},

		beforeRouteUpdate(to, from, next) {
			// Restaure l'étape depuis la query URL (retour/avant navigateur)
			const stepByQuery = { 'country': 2, 'mares': 3 }
			this.step = stepByQuery[to.query.pax_step] || 1
			next()
		},

		created() {
			this.init_component()
		},

		methods: {
			async init_component() {
				document.querySelector('html').classList.remove('no_scroll')
				this.mares_selected = []

				const lang = this.getConfig('lang')
				const country = this.getConfig('country')

				if (this.$route.query.pax_step === 'mares') {
					this.step = 3
				} else if (this.$route.query.pax_step === 'country') {
					this.step = 2
				} else if (lang && country) {
					this.step = 3
				} else if (lang && !country) {
					this.step = 2
				} else {
					this.step = 1
				}
			},

			goToCountry() {
				this.$router.push({ name: 'paxSuggestion', query: { pax_step: 'country' } })
			},

			goToPax() {
				this.$router.push({ name: 'paxSuggestion', query: { pax_step: 'mares' } })
			},
		},

		components: {
			HeaderTab: () => import('@/components/HeaderTab'),
			MaresSuggestion: () => import('@/components/Pax/MaresSuggestion'),
			ChoixLangue: () => import('@/components/Pax/ChoixLangue'),
			ChoixCountry: () => import('@/components/Pax/ChoixCountry'),
		}
	};
</script>
